import { render } from "./IFSModal.vue?vue&type=template&id=5e311272&scoped=true"
import script from "./IFSModal.vue?vue&type=script&lang=js"
export * from "./IFSModal.vue?vue&type=script&lang=js"

import "./IFSModal.vue?vue&type=style&index=0&id=5e311272&lang=scss&scoped=true"
import "./IFSModal.vue?vue&type=style&index=1&id=5e311272&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e311272"]])

export default __exports__